export const GET_USER = "GET_USER";
export const GET_USERS = "GET_USERS";

export const GET_ARTICLES = "GET_ARTICLES";
export const GET_DETAIL_ARTICLE = "GET_DETAIL_ARTICLE";

export const GET_CONSULTATIONS = "GET_CONSULTATIONS";
export const GET_CONSULTATION = "GET_CONSULTATION";
export const GET_REPLY = "GET_REPLY";